import styled, { css } from 'styled-components'
// @ts-ignore
import { sys, colorUtils } from '@netbasequid/theme'
import { AutomationId, AUTO_ATTR_KEY } from 'utils/automationUtil'

interface StyledOuterBoxProps {
  size: 'sm' | 'md' | 'lg'
  isDisabled: boolean
}

const fixedHeight = css`
  height: 46px;
`

const responsiveHeight = css`
  min-height: 64px;
`

export const StyledOuterBox = styled.div.attrs({
  [AUTO_ATTR_KEY]: AutomationId.tile.container
})<StyledOuterBoxProps>`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  min-width: 204px;
  border-radius: 2px;
  padding: ${({ size }) => {
    switch (size) {
      case 'sm':
        return '1px 8px'
      case 'md':
        return '8px 8px'
      case 'lg':
        return '0 8px'
      default:
        return '1px 8px'
    }
  }};
  background-color: ${({ color, theme }) =>
    color ? colorUtils.convertHexToRGBA(color, 0.1) : sys[theme].elevation[0].background};
  color: ${({ theme }) => sys[theme].text.placeholder};
  opacity: ${({ isDisabled }) => (isDisabled ? 0.4 : 1)};
  ${({ size }) => (size === 'sm' ? fixedHeight : responsiveHeight)}
`

export const StyledTitle = styled.div.attrs({ [AUTO_ATTR_KEY]: AutomationId.tile.title })`
  width: 100%;
  height: 22px;
  overflow: hidden;
  text-align: center;
  color: ${({ theme }) => sys[theme].text.primary};
  font-weight: ${sys.fontWeight.regular};
  font-size: ${sys.typescale[14].size};
  line-height: ${sys.typescale[14].lineHeight};
  margin-bottom: ${({ size }: { size: 'sm' | 'md' | 'lg' }) => {
    switch (size) {
      case 'sm':
        return '-4px'
      case 'md':
        return '0px'
      case 'lg':
        return '0px'
      default:
        return '-4px'
    }
  }};
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  word-break: break-all;
`

export const StyledValueSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`

export const StyledValue = styled.div.attrs({ [AUTO_ATTR_KEY]: AutomationId.tile.value })<{
  hasMarginRight: boolean
}>`
  color: ${({ theme }) => sys[theme].text.primary};
  font-weight: ${sys.fontWeight.medium};
  font-size: ${sys.typescale[18].size};
  line-height: ${sys.typescale[18].lineHeight};
  ${({ hasMarginRight }) => hasMarginRight && 'margin-right: 6px;'}
`

export const StyledVariationIcon = styled.div.attrs({
  [AUTO_ATTR_KEY]: AutomationId.tile.variationIcon
})`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 4px;
`

export const StyledVariationValue = styled.div.attrs({
  [AUTO_ATTR_KEY]: AutomationId.tile.variationValue
})`
  color: ${({ color, theme }) => color || sys[theme].text.placeholder};
  font-weight: ${sys.fontWeight.regular};
  font-size: ${sys.typescale[18].size};
  line-height: ${sys.typescale[18].lineHeight};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`
